import React from 'react';
import LoaderLayout from 'components/Layouts/LoaderLayout';
import FeatureFlagsContext, { CONNECT_AUTHENTICATION_FLAG } from 'storage/FeatureFlagsContext';
import withConnectAuthRequired from './withConnectAuthRequired';
import withLegacyAuthRequired from './withLegacyAuthRequired';

export default function withAuthRequired(Component) {
  function WithAuthFlagSelector(props) {
    const { isEnabled, isFetching } = FeatureFlagsContext.useContext();

    if (isFetching) return <LoaderLayout isLoading />;

    const wrap = isEnabled(CONNECT_AUTHENTICATION_FLAG) ? withConnectAuthRequired : withLegacyAuthRequired;

    const Wrapped = wrap(Component);
    return <Wrapped {...props} />;
  }

  return WithAuthFlagSelector;
}
